export default "__VITE_ASSET__Cf0J93xh__"